import { TooltipProps, Typography } from '@mui/material'
import { Tooltip } from '~components/tooltip'
import { useNavigation } from '../../navigation-context'

export function MenuItemTooltip(props: TooltipProps) {
  const { isOpen: isMenuOpen } = useNavigation()
  const { children, title, ...rest } = props

  if (isMenuOpen) return <>{children}</>

  return (
    <Tooltip
      arrow
      title={<Typography variant="menu">{title}</Typography>}
      placement="right"
      {...rest}
    >
      <>{children}</>
    </Tooltip>
  )
}
